"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Link } from "@/components/common/Link";
export default function TheCeoProblem() {
  const {
    ref: imageRef,
    isVisible: imageVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.3
  });
  const {
    ref: textRef,
    isVisible: textVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.3
  });
  return <section id="the-ceo-problem" className="relative bg-background bg-cover bg-center !bg-[url(https://newmavericks.com/wp-content/uploads/2026/03/ceo_disruption_analytics_bg.webp)] py-20 px-8 min-h-[600px] !bg-[url(https://newmavericks.com/wp-content/uploads/2026/03/city.jpg)] !h-[550px]">
      {}
      <div className="absolute inset-0 bg-black/15"></div>
      
      {}
      <div className="relative z-10 max-w-7xl mx-auto">
        <div className="grid grid-cols-2 gap-12 items-center ![margin:30px_0px_0px_0px]">
          {}
          <div ref={textRef} className="flex flex-col gap-6 transition-all duration-[var(--duration-slow)] ease-[var(--ease-out-back)] lg:order-1" style={{
          opacity: textVisible ? 1 : 0,
          transform: textVisible ? "translateX(0)" : "translateX(3rem)"
        }}>
            <h2 className="font-display font-bold text-foreground leading-tight ![margin:-50px_0px_0px_0px] !text-4xl">The CEO Problem</h2>

            <p className="text-muted-foreground leading-relaxed mt-4 !text-xl">Data from a 2022 Alix Partners Disruption Index reports 58% of CEOs are replaced within two years of a VC investment &amp; 73% replaced over the lifetime of an investment. <br /><br />In the last couple of years CEOs have been quitting at a record pace indicating many CEOs struggle with having the leadership capacity to protect themselves, performance &amp; progress of their companies.</p>
          </div>

          {}
          <div ref={imageRef} className="transition-all duration-[var(--duration-slow)] ease-[var(--ease-out-back)] lg:order-2" style={{
          opacity: imageVisible ? 1 : 0,
          transform: imageVisible ? "translateX(0)" : "translateX(-3rem)"
        }}>
            <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1524742/img/image_cxbahane.jpg" alt="CEO Leadership Challenge" className="w-full rounded-lg shadow-medium object-cover h-[350px]" />
          </div>
        </div>
      </div>
    </section>;
}